<template>
  <div class="container">
    <div class="col-lg-6 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white">
          <br />
          <br />
          <div class="row text-center">
            <div class="col-lg-12 text-center">
              <div
                style="
                  display: inline;
                  text-align: center;
                  padding-top: 5%;
                  bottom: 0;
                "
              >
                <img src="img/LCDA Logo.png" width="60" height="90" alt />
              </div>
              <div
                style="
                  display: inline;
                  text-align: center;
                  
                  bottom: 0;
                "
              >
                <img src="img/tm.jpeg" alt width="100" style="padding-top: 8%;"/>
              </div>
              <br />
              <br />
              <br />
              <br />
              <h6
                style="
                  color: #73786f;
                  font-size: 28px;
                  text-align: center;
                  padding-top: 1%;
                "
              >
                Sign In
              </h6>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-7 text-center input-container" >
              <i class="fa fa-user icon" aria-hidden="true"></i>
              <!-- class="input-field" -->
              <input
             
                type="text"
                class="input-field"
                v-validate="'required|email'"
                name="email"
                :error="getError('email')"
                v-model="model.email"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
              />
            </div>
            <div class="col-lg"></div>
          </div>

          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-7 text-center input-container">
              <i class="fa fa-lock icon" aria-hidden="true"></i>
              <!-- class="input-field" -->
              <input
                class="input-field"
                v-validate="'required'"
                name="password"
                :error="getError('password')"
                v-model="model.password"
                type="password"
                placeholder="Password"
                addon-left-icon="tim-icons icon-lock-circle"
              />
            </div>
            <div class="col-lg"></div>
          </div>

          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-8 text-center">
              <base-button
                v-on:click="login()"
                native-type="submit"
                style="background-color: #1c793c; text-align: center;background-image: linear-gradient(#076126, #40a261);"
                class="mb-3 btn-round"
                size="lg"
                block
              >
                Sign In
              </base-button>
              <p style="color: red" v-html="model.message"></p>
            </div>
            <div class="col-lg"></div>
          </div>

          <!-- </router-link> -->
          <div class="pull-left">
            <h6>
              <!-- <router-link class="link footer-link" to="/register">
                  Create Account
                </router-link>-->
            </h6>
          </div>

          <div class="pull-right">
            <!-- <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6> -->
          </div>
          <!-- </div> -->
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";

export default {
  name: "Login",
  data() {
    return {
      buildres: "",
      model: {
        // demo@vectolabs.com
        // test123
        email: "",
        password: "",
        message: "",
      },
    };
  },
  methods: {
    login() {
      let payload = {
        useremail: this.model.email,
        userpass: this.model.password,
      };

      if (navigator.onLine) {
        this.$http
          .post(":8002/api/auth/login", payload)
          .then((res) => {
            if (res.error) {
              //pupout oeror
             
              this.model.message = res.message;
            } else {
              //login OK!
              if (res.message.jwt_token) {
               
                sessionStorage.setItem("token", res.message.jwt_token);
                sessionStorage.setItem(
                  "username",
                  res.message.UserInfo.UserName
                );
                //send to cookie
                this.$cookie.set("token", res.message.jwt_token);
                this.$router.push("/dashboard");
              } else {
                swal({
                  type: "error",
                  title: "Unable to communicate with the services",
                });
              }
            }
          })
          .catch((err) => {
         
            swal({
              type: "error",
              title: "Oops... You have no internet conncetion!",
            });
          
          });
      } else {
        swal({
          type: "error",
          title: "Oops... You have no internet conncetion!",
        });
      }
    },
    loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }

      localStorage.token = req.data.token;
      this.error = false;

      this.$router.replace(this.$route.query.redirect || "/lightpage");
    },
    loginFailed() {
      this.error = "Login failed!";
      // this.message = res.message;
      delete localStorage.token;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  mounted() {},
  created() {
    this.buildres = process.env.VUE_APP_BUILD_RES;
    if (this.buildres == "BETA v1.0" || this.buildres == "PRODUCTION") {
      this.model.email = "";
      this.model.password = "";
    }
    const loggedIn = sessionStorage.getItem("token");
    if (this.$cookie.get("token") != null) {
      this.$router.push("/dashboard");
    }
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.input-container {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid #b2b2b2;
  border-radius: 20px;
  background: #ffffff;
  
}

.icon {
  padding: 15px;
  /* background: dodgerblue; */
  color: #807f80;
  min-width: 50px;
  text-align: center;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: none;
  /* border-radius: 1px solid pink; */
  /* outline: none; */
}

.input-field:focus {
  border: none;
  outline: none;
}

/* .input-field {
  width: 100%;
  padding: 5px;
  padding-top: 0px;
  text-align: center;

  border-bottom: 1px solid #c7c7c7;
  border-left: none;
  border-right: none;
  border-top: none;
  background: transparent;

  margin-bottom: 5px;
  color: #4f4b4b;
}

.input-field:focus {
  outline: none;
  padding-top: 0px;
  color: white;
  
  border-bottom: 1px solid #c7c7c7;
  border-left: none;
  border-right: none;
  background: transparent;
  margin-bottom: 5px;
  border-top: none;
  font: bold;
} */

/* .input-field {
  width: 100%;
  padding: 10px;
  padding-left: 20px;
  text-align: left;
  border-radius: 50px;
  border: 1px solid #c7c7c7;


}

.input-field:focus {
  outline: none;
  border: 1px solid #009a78;
} */

/* .input-icons i {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
}

.icon {
  padding: 15px;
  min-width: 40px;
}

.input-field {
  width: 100%;
  padding: 10px;
  
  text-align: left;
} */


</style>
